export enum ProviderImagesUrlTiny {
  AA = `${MAIN_SITE_URL}/provider-logos/0.5x/aa.webp`,
  AIA = `${MAIN_SITE_URL}/provider-logos/0.5x/aia.webp`,
  ASTERON_LIFE = `${MAIN_SITE_URL}/provider-logos/0.5x/asteron-life.webp`,
  CIGNA = `${MAIN_SITE_URL}/provider-logos/0.5x/cigna.webp`,
  COVE = `${MAIN_SITE_URL}/provider-logos/0.5x/cove.webp`,
  FIDELITY_LIFE = `${MAIN_SITE_URL}/provider-logos/0.5x/fidelity-life.webp`,
  INITIO = `${MAIN_SITE_URL}/provider-logos/0.5x/initio.webp`,
  PARTNERS_LIFE = `${MAIN_SITE_URL}/provider-logos/0.5x/partners-life.webp`,
  PINNACLE = `${MAIN_SITE_URL}/provider-logos/0.5x/pinnacle.webp`,
  PROTECTA = `${MAIN_SITE_URL}/provider-logos/0.5x/assurant.webp`,
  TOWER = `${MAIN_SITE_URL}/provider-logos/0.5x/tower.webp`,
  AUTOSURE = `${MAIN_SITE_URL}/provider-logos/0.5x/autosure.webp`,
  TRADE_ME = `${MAIN_SITE_URL}/provider-logos/0.5x/trade-me.webp`,
  AMP = `${MAIN_SITE_URL}/provider-logos/0.5x/amp.webp`,
  PROVIDENT = `${MAIN_SITE_URL}/provider-logos/0.5x/provident.webp`,
}

export enum ProviderImagesUrlSmall {
  AA = `${MAIN_SITE_URL}/provider-logos/0.5x/aa_sm.webp`,
  AUTOSURE = `${MAIN_SITE_URL}/provider-logos/0.5x/autosure_sm.webp`,
  COVE = `${MAIN_SITE_URL}/provider-logos/0.5x/cove_sm.webp`,
  INITIO = `${MAIN_SITE_URL}/provider-logos/0.5x/initio_sm.webp`,
  PROTECTA = `${MAIN_SITE_URL}/provider-logos/0.5x/assurant_sm.webp`,
  TOWER = `${MAIN_SITE_URL}/provider-logos/0.5x/tower_sm.png`,
  TRADE_ME = `${MAIN_SITE_URL}/provider-logos/0.5x/trademe_sm.png`,
  AMP = `${MAIN_SITE_URL}/provider-logos/0.5x/amp_sm.png`,
  STAR = `${MAIN_SITE_URL}/provider-logos/0.5x/star_sm.webp`,
  PROVIDENT = `${MAIN_SITE_URL}/provider-logos/0.5x/provident_sm.webp`,
}
